import React from 'react'
const Link = ({
                href, children
              }) => {
  const isLinkAvailable = href && href !== '#';

  if (!isLinkAvailable) {
    return <span>{children}</span>;
  }

  return (
    <a href={href} target="_blank">{children}</a>
  );
}
export default Link;
